export default "__VITE_ASSET__9KfjS$ZR__"